import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const AreasContext = React.createContext();

function AreasProvider({ children }) {
  const [areas, setAreas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  async function getAreas() {
    try {
      const path = location.pathname;
      if (path.includes('/areas') && !path.includes('facilities')) {
        setIsLoading(true);
        const { data } = await axios.get(`/areas`);
        if (data) {
          setAreas(data);
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getAreas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AreasContext.Provider
      value={{
        areas,
        getAreas,
        isLoading,
      }}
    >
      {children}
    </AreasContext.Provider>
  );
}

export default AreasProvider;
